import React from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";

import "./FormList.css";

import history from "../../../../history";
import { getFormsList, getFormFile, deleteForm } from "../../../../actions/formsActions";

import Modal from "../../../CustomViews/Modal";

class FormList extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            modal: false,
            modalAction: null
        };
    }
    
    componentDidMount() {
        this.props.getFormsList();
    }

    onDeleteClick = formID => this.setState({
        modal: true,
        modalAction: formID
    });

    renderModal = () => {
        if (this.state.modal) {
            return (
                <Modal
                    title="Usunięcie formularza"
                    content={<p>Czy na pewno chcesz usunąć ten formularz? Tej operacji nie można cofnąć.</p>}
                    actions={(
                        <React.Fragment>
                            <button onClick={() => history.go(0)} className="ui button">Anuluj</button>
                            <button onClick={() => this.props.deleteForm(this.state.modalAction)} className="ui negative button">Usuń</button>
                        </React.Fragment>
                    )}
                    onDismiss={() => history.go(0)}
                />
            );
        }
    };

    renderForms = () => this.props.formList.map(form => {
        return (
            <div className="ui segment-wrapper" key={form.formID}>
                <div className="ui segment">
                    <div className="ui grid">
                        <div className="row">
                            <div className="eleven wide column">
                                <div className="ui big header">{form.title}</div>
                            </div>
                            <div className="five wide column">
                                <div className="content">
                                    <span className="placeholder">Ilość pobrań: {form.downloadCount}</span>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="eleven wide column">
                                <div className="content">
                                    <span className="placeholder">{form.description}</span>
                                </div>
                            </div>
                            <div className="five wide column">
                                <div className="content">
                                    <button className="ui primary button" type="button" onClick={() => this.props.getFormFile(form.formID)}>Pobierz</button>
                                    {this.props.currentUser.ouID === +process.env.REACT_APP_HR_OU_ID ? (
                                        <React.Fragment>
                                            <button className="ui button" type="button" onClick={() => history.push(`/forms/edit/${form.formID}`)}>Edytuj</button>
                                            <button className="ui negative button" type="button" onClick={() => this.onDeleteClick(form.formID)}>Usuń</button>
                                        </React.Fragment>
                                    ) : null}
                                </div>
                            </div>
                        </div>
                    </div>  
                </div>
            </div>
        );
    });

    render() {
        return (
            <React.Fragment>
                <div className="form-list-component ui container">
                    {this.props.currentUser.ouID === +process.env.REACT_APP_HR_OU_ID ? (
                        <React.Fragment>
                            <div className="ui two item menu">
                                <Link to="/forms" className="active item">
                                    <div className="content">Lista formularzy</div>
                                </Link>
                                <Link to="/forms/new" className="item">
                                    <div className="content">Nowy formularz</div>
                                </Link>
                            </div>
                            <div className="ui divider" />
                        </React.Fragment>
                    ) : null}
                    {this.props.formList.length ? (
                        <React.Fragment>
                            <div className="ui large header">
                                <div className="content">Formularze do pobrania:</div>
                            </div>
                            {this.renderForms()}
                        </React.Fragment>
                    ) : (
                        <div className="ui grid">
                            <div className="column">
                                <h2 className="ui icon header">
                                    <i className="pdf file icon"></i>
                                    <div className="content">Nie odnaleziono formularzy</div>
                                </h2>
                            </div>
                        </div>
                    )}
                </div>
                {this.renderModal()}
            </React.Fragment>
        );
    }
}

const mapStateToProps = state => ({
    currentUser: state.user.current,
    formList: state.forms.list
});

export default connect(mapStateToProps, { getFormsList, getFormFile, deleteForm })(FormList);